import { Form } from 'factorial-form'

import { TENURE_BALANCE_TYPES, TENURE_PERIOD_TYPES } from 'modules/timeoff/lib/TenurePeriod'
import type { ITenurePeriod as PeriodAttributes } from 'modules/timeoff/lib/TenurePeriod'

class TenurePeriodForm extends Form {
  constructor(
    values: PeriodAttributes = {
      period_type: TENURE_PERIOD_TYPES.years,
      period_length: 0,
      balance_type: TENURE_BALANCE_TYPES.fixed_balance,
      time_worked_based_hours_accrued_in_cents: undefined,
      time_worked_based_per_hours_worked_in_cents: undefined,
      adjustment_in_cents: undefined,
    }
  ) {
    super(
      { ...values },
      {
        period_type: 'string',
        period_length: 'number',
        balance_type: 'string',
        time_worked_based_hours_accrued_in_cents: 'cents',
        time_worked_based_per_hours_worked_in_cents: 'cents',
        adjustment_in_cents: 'cents',
        max_cap_in_cents: 'cents',
        temp_id: 'number',
        id: 'number',
      }
    )
  }
}

export default TenurePeriodForm
